import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder,FormGroup,Validators } from '@angular/forms';
import { CountryService } from '../country.service';
import Swal from 'sweetalert2/dist/sweetalert2.js'; 
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-country',
  templateUrl: './create-country.component.html',
  styleUrls: ['./create-country.component.scss'],
  
})
export class CreateCountryComponent implements OnInit {
  errors: string[] | null = [];
  countriesForm:FormGroup
  @ViewChild('modal') modal: ElementRef;

  constructor(public activeModal: NgbActiveModal,private fb:FormBuilder,
    public countrySerivce:CountryService, public router:Router,
    private toastr: ToastrService
  ){
    
}

ngOnInit(): void {
  this.countriesForm=this.fb.group({
    Name: ['', [Validators.required, Validators.maxLength(100)]],
    PhoneCode: ['', [Validators.required, Validators.maxLength(100)]],
    ZipCode: ['', [Validators.required, Validators.maxLength(100)]],
  });

}
// Function to close the modal
Close(){
  
}
onSubmit()
{
  if (!this.countriesForm.valid) return this.countriesForm.markAllAsTouched();
  this.countriesForm=this.fb.group({
    Name: this.countriesForm.value.Name,
    PhoneCode: this.countriesForm.value.PhoneCode,
    ZipCode: this.countriesForm.value.ZipCode,
    IsActive:true
  })
  console.log(this.countriesForm.value)
   this.countrySerivce.createCountry(this.countriesForm.value)
   .subscribe({
    next: r=>{
      // Swal.fire('Created', '', 'success')
      this.toastr.success('Deleted!', 'Country has been deleted');
      this.activeModal.close({ refresh: true });
    },
    error: e => {
      if(e.error.message){
        this.toastr.error('Oops!', e.error.message);
      }
      else{
        this.toastr.error('Oops!', "Something went wrong");
      }
    }
   })
   
}
}
